import type { Device } from '@/types/api';
import { SignalIcon } from './signal-icon';

interface DeviceNameCellProps {
  device: Device;
  showLocation?: boolean;
}

export function DeviceNameCell({ device, showLocation = true }: DeviceNameCellProps) {
  const location = device.buildingName && device.unitNumber
    ? `${device.buildingName} \u2013 Unit ${device.unitNumber}`
    : device.buildingName
      ? device.buildingName
      : device.unitNumber
        ? `Unit ${device.unitNumber}`
        : null;

  return (
    <div className="flex items-start gap-2">
      <div className="min-w-0">
        <span className="font-medium text-gray-900 dark:text-gray-100">{device.serialNumber}</span>
        {showLocation && (
          <div className="flex items-center gap-1.5 mt-0.5">
            {location ? (
              <span className="text-xs text-gray-500 dark:text-gray-400 truncate">{location}</span>
            ) : (
              <span className="text-xs text-gray-400 dark:text-gray-500 italic">Unassigned</span>
            )}
            <SignalIcon
              rssi={device.latestTransmission?.rssi}
              meta={{
                snr: device.latestTransmission?.snr,
                spreadingFactor: device.latestTransmission?.spreadingFactor,
                gatewayEui: device.latestTransmission?.gatewayEui,
                timestamp: device.latestTransmission?.timestamp ?? device.lastSeenAt,
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}
